<template>
  <div class="users-merge-block__options-row">
    <v-radio-group  v-model="indexValue" class="my-0 py-0" @change="changeValue" row hide-details>
      <div v-for="(user, index) in mergeData" :key='index' class="users-merge-block__option-holder d-flex align-center">
        <v-radio :value="index" class="my-0">
          <template v-slot:label>
            <div v-if="keyName === 'status'">{{ statusValue(user[keyName]) }}</div>
            <div v-else-if="keyName === 'isSecretary' || keyName === 'sendEndingLettersViaEDI'">{{ booleanValue(user[keyName]) }}</div>
            <div v-else>{{ `${user[keyName] ? user[keyName] : ''}` }}</div>
          </template>
        </v-radio>
      </div>
    </v-radio-group>
  </div>
</template>

<script>
  import {USERS_STATUS_VALUES} from '@/constants/usersTypes';

  export default {
    name: 'UsersMergeOption',

    props: ['keyName', 'mergeData'],

    data: function () {
      return {
        indexValue: null,
      };
    },

    methods: {
      booleanValue: function(value) {
        if (value) {
          return 'Ja'
        } else {
          return 'Ingen'
        }
      },
      statusValue: function (statusValue) {
        return USERS_STATUS_VALUES[statusValue];
      },
      changeValue: function () {
        if (this.mergeData[this.indexValue] !== undefined) {
          this.$emit('changeValue', this.mergeData[this.indexValue][this.keyName]);
        }
      },
      setValue: function (value) {
        this.indexValue = value;
        this.changeValue();
      },
    },
  };
</script>
